import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onUnmounted, PropType,  ref, watch } from "vue";
import { DialogComponent } from "@syncfusion/ej2-vue-popups";
import { SogDialogButtons } from "@/shared/ui/types/SogDialogButtons";


export default /*@__PURE__*/_defineComponent({
  __name: 'SogDialog',
  props: {
  target:{
    type: String,
    default: ""
  },
  dialogButtons:{
    type: String as PropType<SogDialogButtons>,
    default: SogDialogButtons.Ok
  },
  header:{
    type: String,
    default: ""
  },
  width: {
    type: String,
    default: ""
  },
},
  emits: ["clickOk", "clickCancel"],
  setup(__props, { expose: __expose, emit: __emit }) {


const _props= __props

const _emits = __emit


const _dialog = ref<DialogComponent | null>(null)


const _dialogButtons = ref(_props.dialogButtons)
const _header = ref(_props.header)

const _width = ref(_props.width?_props.width:window.innerWidth<500?"85%":"500px")

//const _height = ref(_props.height?_props.height:"auto")


const _buttons = ref([{ buttonModel: { isPrimary: true, content: 'Ok', iconCss: 'e-icons e-ok-icon' }, click: doYes }])

watch(_dialogButtons,()=>{
  switch (_dialogButtons.value) {
    case SogDialogButtons.YesNo:
      _buttons.value = [{ buttonModel: { isPrimary: true, content: 'Ja', iconCss: 'e-icons e-ok-icon' }, click: doYes },
        { buttonModel: { isPrimary: false, content: 'Nein', iconCss: 'e-icons e-close-icon' }, click: doNo }
      ]
      break
    case SogDialogButtons.Ok:
      _buttons.value = [{ buttonModel: { isPrimary: true, content: 'Ok', iconCss: 'e-icons e-ok-icon' }, click: doYes }
        /*
        { buttonModel: { isPrimary: false, content: 'No', iconCss: 'e-icons e-close-icon' }, click: this.doNo }
*/
      ]
      break
    case SogDialogButtons.SaveCancel:
      _buttons.value = [{ buttonModel: { isPrimary: true, content: 'Save', iconCss: 'e-icons e-save-icon' }, click: doYes },
        { buttonModel: { isPrimary: false, content: 'Cancel', iconCss: 'e-icons e-cancel-icon' }, click: doNo }
      ]
      break
    case SogDialogButtons.OkCancel:
      _buttons.value = [{ buttonModel: { isPrimary: true, content: 'Ok', iconCss: 'e-icons e-ok-icon' }, click: doYes },
        { buttonModel: { isPrimary: false, content: 'Cancel', iconCss: 'e-icons e-cancel-icon' }, click: doNo }
      ]
      break
  }
},{immediate:true})

const _onYes = ref<undefined| (() => void)>(undefined)
const _isModal = ref(true);


function doNo ():void{
  _emits("clickCancel")
  if(_isModal.value) {
    _dialog.value?.hide()
    _onYes.value = undefined
  }
}

function doYes ():void{
  _emits("clickOk")
  if(_isModal.value) {
    _dialog.value?.hide()
    if (_onYes.value) {
      _onYes.value()
    }
    _onYes.value = undefined
  }
}

const _content = ref("")

function show () {
  _isModal.value = false;
  _onYes.value = undefined
  _dialog.value?.show()
}

function hide() {
  _dialog.value?.hide()
}


const showModal = (onSave: () => void) => {
  _isModal.value = true;
  _onYes.value = onSave
  _dialog.value?.show()
}

const showOk = (title: string, message: string, onOk: (() => void)|undefined = undefined) => {
//  this._onYes = onSave
  //    this.dialogButtons = DialogButtons.SaveCancel
  _isModal.value = true;
  _header.value = title
  _content.value = message
  _dialogButtons.value = SogDialogButtons.Ok
  _onYes.value = onOk
  _dialog.value?.show()
}

const showYesNo = (title: string, message: string, onYes: () => void):boolean =>{
  _isModal.value = true;
  _dialogButtons.value = SogDialogButtons.YesNo
  _header.value = title
  _content.value = message
  _onYes.value = onYes
  _dialog.value?.show()
  return true
}



onMounted(() => {
  window.addEventListener('resize', () => {_width.value = _props.width?_props.width:window.innerWidth<500?"85%":"500px"} )
})
onUnmounted(() => {
  window.removeEventListener('resize', () => {_width.value = _props.width?_props.width:window.innerWidth<500?"85%":"500px"})
})

__expose({
  showModal, showOk,showYesNo,show,hide
})

/*
onMounted(()=>{
  notificationService.initDialog(this)
})
*/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogComponent), {
    id: "dialog",
    ref_key: "_dialog",
    ref: _dialog,
    width: _width.value,
    height: "auto",
    "is-modal": "true",
    target: __props.target,
    visible: false,
    "close-on-escape": true,
    "show-close-icon": false,
    content: _content.value,
    buttons: _buttons.value,
    header: _header.value
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["width", "target", "content", "buttons", "header"]))
}
}

})